// extracted by mini-css-extract-plugin
module.exports = {"avatarBlock":"styles-styles-module--avatarBlock--exNLy"};